





























































import { Component, Prop } from "vue-property-decorator";
import DataTable from "@/shared/components/data-table.vue";
import Assinaturas from "@/shared/components/assinatura.vue";
import DadosAtendimento from "./components/DadosAtendimento.vue";
import GlobalMixin from "@/shared/mixins/globalMixin";
import { mixins } from "vue-class-component";
import DadosConsultor from "./components/DadosConsultor.vue";
import RegistrarChamadas from "./components/RegistrarChamadas.vue";
import Planos from "@/shared/components/tabela-planos.vue";
import UltimosAcessos from "./tables/UltimosAcessos.vue";
import Atendimentos from "./tables/Atendimentos.vue";
import Tickets from "./tables/Tickets.vue";
import Tooltip from "@/shared/components/tooltip.vue";
import { ConsultoresService } from "@/services/consultores.service";
import MensagemErro from "./modals/MensagemErro.vue";

@Component({
  components: {
    DataTable,
    Assinaturas,
    DadosConsultor,
    DadosAtendimento,
    RegistrarChamadas,
    Planos,
    UltimosAcessos,
    Atendimentos,
    Tickets,
    Tooltip,
    MensagemErro,
  },
})
export default class DetalhesAtendimento extends mixins(GlobalMixin) {
  @Prop() idConsultor!: number;
  registrarChamadaAtivo = false;
  tamCol = 8;
  atendimento: any | null = null;

  voltar() {
    this.$router.back();
  }

  async acessarPainel() {
    this.startLoader();
    const acess = await ConsultoresService.AcessarPainel(
      Number(this.$route.params.idConsultor)
    ).finally(this.stopLoader);
    if (acess.erro) {
      const modal = this.$refs.mensagemErro as MensagemErro;
      await modal.exibirMensagem(acess.urlMensagem);
    } else {
      window.open(acess.urlMensagem);
    }
  }

  ativarChamada(e: boolean) {
    this.registrarChamadaAtivo = e;
    if (e) {
      this.tamCol = 4;
    }
  }
}
